import { useEffect, useState } from 'react';

const KEY = 'aleaces_onboarded';

function wasOnboarded(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return true; // storage blocked: don't nag on every visit
  }
}

function markOnboarded(): void {
  try {
    localStorage.setItem(KEY, '1');
  } catch { /* ignore */ }
}

/** First-visit intro: explains the tavern in three sentences. Shown once,
 * dismissed state lives in localStorage (per device, like sound settings). */
export function OnboardingModal() {
  const [open, setOpen] = useState(() => !wasOnboarded());

  useEffect(() => {
    if (!open) return;
    const fn = (e: KeyboardEvent) => {
      if (e.key === 'Escape') close();
    };
    window.addEventListener('keydown', fn);
    return () => window.removeEventListener('keydown', fn);
  }, [open]);

  function close(): void {
    markOnboarded();
    setOpen(false);
  }

  if (!open) return null;
  return (
    <div className="modal" role="dialog" aria-modal="true" aria-labelledby="onboarding-title">
      <div className="modal-box" style={{ maxWidth: 520 }}>
        <div className="eyebrow">Willkommen in der Taverne</div>
        <h2 id="onboarding-title">So spielt sich Ale &amp; Aces</h2>
        <div style={{ display: 'grid', gap: 12, margin: '14px 0 18px', fontFamily: 'var(--font-ui)', fontSize: 14, textAlign: 'left' }}>
          <p style={{ margin: 0 }}>
            <b style={{ color: 'var(--gold-hi)' }}>🎲 Zufallsheld:</b> Du suchst zuerst ein Turnier. Steht der Tisch,
            lost dir die Taverne einen zufälligen Helden aus deiner Sammlung zu – einmal neu ziehen ist erlaubt.
          </p>
          <p style={{ margin: 0 }}>
            <b style={{ color: 'var(--gold-hi)' }}>✨ Heldenkraft:</b> Jeder Held hat eine Kraft, die du
            einmal pro Turnier einsetzen kannst. Am Tisch helfen die Tasten <b>F</b> (Fold) und <b>C</b> (Check/Call).
          </p>
          <p style={{ margin: 0 }}>
            <b style={{ color: 'var(--gold-hi)' }}>🍺 Nur Kosmetik:</b> EP, Taler, Quests und Battlepass schalten
            ausschließlich Skins und Verzierungen frei. Chips kann man nie kaufen – am Tisch zählt nur dein Spiel.
          </p>
        </div>
        <button className="btn gold" autoFocus onClick={close}>Alles klar – zeig mir die Taverne</button>
      </div>
    </div>
  );
}
